import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

// Minimal navbar for the brochure view page — only the Crio.Do logo.
// Extracted from the FSP-style PPCNavbar so we don't pull in the anchor
// menu or the mobile hamburger, which aren't meaningful on a single-purpose
// brochure page.
const MinimalBrochureNavbar = () => {
  return (
    <div
      id="brochure-navbar"
      className="fixed top-0 left-0 z-[1000] w-full border-b border-v5-neutral-200 bg-white"
    >
      <div className="flex h-[64px] w-full items-center px-5 md:px-8">
        <Link
          to="/"
          aria-label="Go to Crio.Do home"
          className="inline-flex items-center"
        >
          <StaticImage
            loading="eager"
            src="../../images/Crio_Dark.png"
            placeholder="none"
            alt="Crio.Do"
            className="h-[36px] w-[100px] md:w-[130px]"
            imgStyle={{ objectFit: 'contain' }}
          />
        </Link>
      </div>
    </div>
  );
};

export default MinimalBrochureNavbar;
